export default "__VITE_ASSET__264c3304__"